export const brandName = "Joypicturestudio";

export const phoneNumber = +918073574787;

export const whatsappLink = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text&type=phone_number&app_absent=0`;

export const email = "info@joypicturestudio.com";
